import type { IconProps } from '../types/IconProps.ts';
export const UserSearch: IconProps = {
    name: 'UserSearch',
    children: [
        `<path d="M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10" />`,
        `<path d="M15.15 13.64A8 8 0 0 0 4 21" />`,
        `<circle cx="19" cy="19" r="2" />`,
        `<path d="M20.5 20.5 22 22" />`,
    ]
};